import React, {useState} from "react";
import "./App.css";
import {Link, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

function App() {
    const navigate = useNavigate();

    const [orderId, setOrderId] = useState("");

    const trackOrder = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!orderId.trim()) {
            toast.error("Inserisci un numero d'ordine valido");
            return;
        }

        navigate(`/track/${orderId}`);
    };

    return (
        <div className="bg-blue-50 flex items-center justify-center min-h-screen">
            <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md">

                {/* TITLE */}
                <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
                    Casablanca Riparazioni
                </h2>

                {/* FORM */}
                <form
                    className="space-y-5"
                    onSubmit={trackOrder}
                >

                    {/* ORDER ID */}
                    <div>
                        <label className="block text-gray-600 mb-1">
                            Numero ordine
                        </label>

                        <input
                            value={orderId}
                            onChange={(event) =>
                                setOrderId(event.target.value)
                            }
                            placeholder="3e2fd3c1-f8af-4653-b4ec-13c1dbb700f5"
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* BUTTON */}
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200"
                    >
                        Traccia
                    </button>

                    {/* LOGIN */}
                    <div className="flex items-center justify-between text-sm">
                        <Link
                            to={"/login"}
                            className="text-blue-600 hover:underline"
                        >
                            Area riservata
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default App;